import type {ReactElement} from 'react';
import {useState} from 'react';
import React from 'react';
import styles from './share-signup-form-in-team-toggler.module.scss';
import {ShareInTeamBarState} from '@Components/share-in-team-toggle-bar/share-in-team-toggle-bar.types';
import {ShareInTeamToggleBar} from '../share-in-team-toggle-bar/share-in-team-toggle-bar';
import {isUserPremium} from '@Libraries/user.library';
import {noop} from '@Utils/general.util';
import type {EmailSignupForm} from '@/form-maker/grapesjs-form-maker/src/form-maker.types';
import {shareEmailSignupFormInTeam} from '@Libraries/email-signup-form-library';
import {openShareSignupFormInTeamModal} from '@Modals/share-signup-form-in-team-modal';
import {useIsMobileWidth} from '@Hooks/useIsMobileWidth';
import {useIsInModal} from '@Components/modal/hooks/useIsInModal';

export interface ShareSignupFormInTeamTogglerProps {
  signupForm: EmailSignupForm;
  onStateUpdate?: (state: ShareInTeamBarState) => void;
  className?: string;
}

export function ShareSignupFormInTeamToggler({signupForm, onStateUpdate = noop, className = ''}: ShareSignupFormInTeamTogglerProps): ReactElement {
  const isMobileWidth = useIsMobileWidth();
  const isInModal = useIsInModal();
  const getToggleStateBySignupFormState = (): ShareInTeamBarState => {
    if (!isUserPremium()) {
      return ShareInTeamBarState.UPSELLING;
    }

    if (signupForm.isSharedInTeam) {
      return ShareInTeamBarState.ACTIVE;
    }

    return ShareInTeamBarState.INACTIVE;
  };

  const [isLoading, setIsLoading] = useState(false);
  const [toggleState, setToggleState] = useState(getToggleStateBySignupFormState());

  const updateSharingStatus = async (shareInTeamState: ShareInTeamBarState) => {
    let isSharedInTeam = false;
    if (shareInTeamState === ShareInTeamBarState.ACTIVE) {
      isSharedInTeam = true;
    }

    setIsLoading(true);
    await shareEmailSignupFormInTeam(isSharedInTeam, signupForm.id);
    setIsLoading(false);
    setToggleState(shareInTeamState);
    onStateUpdate(shareInTeamState);
  };

  if (isMobileWidth && !isInModal) {
    openShareSignupFormInTeamModal({signupForm, onStateUpdate});
    return <></>;
  }

  return (
    <div className={className}>
      <ShareInTeamToggleBar
        state={toggleState}
        isCurrentlyLoading={isLoading}
        onStateUpdate={(shareInTeamState: ShareInTeamBarState): void => {
          void updateSharingStatus(shareInTeamState);
        }}
      />
    </div>
  );
}
